/* eslint-disable no-undef */
export class MinimalPubSub {
  constructor() {
    this.listeners = {
      any: [],
    };

    this.listenerObservers = [];
  }

  on = (eventName, listener) => {
    if (this.listeners[eventName]) {
      this.listeners[eventName].push(listener);
    } else {
      this.listeners[eventName] = [listener];
    }
    this.listenerObservers.slice().forEach(o => o({eventName, listener}));
  };
  onAny = listener => {
    this.listeners.any.push(listener);
    this.listenerObservers.slice().forEach(o => o({listener}));
  };
  removeListener = (eventName, listenerOrName) => {
    const listeners = eventName ? this.listeners[eventName] : this.listeners.any;
    let listenerIndex;
    if (typeof listenerOrName === 'function') {
      listenerIndex = listeners.findIndex(l => l === listenerOrName);
    } else {
      listenerIndex = listeners.findIndex(l => l.listenerName === listenerOrName);
    }
    if (listenerIndex !== -1) {
      listeners.splice(listenerIndex, 1);
    }
  };
  emit = (eventName, data) => {
    const listeners = [...this.listeners.any, ...(this.listeners[eventName] || [])];
    listeners.forEach(l => l({eventName, data}));
  };

  hasListener = listenerName => {
    return Object.keys(this.listeners).some(k => {
      return this.listeners[k].find(l => l.listenerName === listenerName);
    });
  };

  addListenerObserver = cb => {
    this.listenerObservers.push(cb);
  }

  removeListenerObserver = cb => {
    this.listenerObservers = this.listenerObservers.slice().splice(this.listenerObservers.indexOf(o => o === cb), 1);
  }
}
